export const componentsTheme = theme => ({
  Accordion: {
    default: {
      backgroundColor: theme.color.white,
    },
    OrderSummary: {
      backgroundColor: theme.color.lighterGrey,
    },
  },
  AccountPage: {
    default: {
      deleteButtonMode: 'danger',
    },
  },
  AccountRewardsIconSteps: {
    default: {
      step1: {
        name: 'Card',
      },
      step2: {
        name: 'Diamond',
      },
      step3: {
        name: 'ShoppingCart',
      },
    },
  },
  Alert: {
    default: {
      danger: '',
      fontSize: {
        small: theme.fontSize.md,
        large: theme.fontSize.xl,
      },
      info: '',
      success: '',
      warning: '',
    },
    'Rewards:OfflinePoints': {
      fontSize: {
        small: theme.fontSize.md,
      },
    },
  },
  CircularProgressBar: {
    default: {
      activeProgressColor: '',
      backgroundColor: 'transparent',
      inactiveProgressColor: '',
      progressWidth: null,
      roundedProgress: true,
    },
    PointsRedemption: {
      progressWidth: 16,
      roundedProgress: false,
    },
  },
  DiscountForm: {
    default: {
      alertType: 'warning',
      sendCodeInUpperCase: true,
      showInputForQRCodeScan: true,
      showInstructions: false,
      showVmosCode: true,
    },
  },
  Footer: {
    default: {
      backgroundColor: '',
    },
    PageFooter: {},
  },
  FriendReferral: {
    default: {
      image: {
        mobile: '',
        desktop: '',
      },
    },
  },
  HowItWorksIconSteps: {
    default: {
      isIconStepsVisible: true,
    },
  },
  HowItWorksImageSteps: {
    default: {
      imageSteps: [],
    },
  },
  KioskAuth: {
    default: {
      loyaltyTextVisible: true,
      visible: true,
    },
    Category: {},
    Checkout: {},
    LoggedIn: {},
    LoggedOut: {},
  },
  LoyaltyAdvert: {
    default: {
      image: '',
    },
  },
  LoyaltyAuthCard: {
    default: {
      image: '',
      visible: false,
    },
    LoggedIn: {},
    LoggedOut: {},
  },
  LoyaltyModal: {
    default: {
      tierImages: [],
      visible: true,
    },
  },
  OfflinePoints: {
    default: {
      backgroundColor: '',
    },
  },
  OfflinePointsSuccess: {
    default: {
      closeButtonColor: theme.color.white,
      confettiColor: theme.color.white,
      confettiImage: '',
      image: '',
      partyHornColor: theme.color.white,
    },
  },
  OrdersHistory: {
    default: {
      noOrdersImage: '',
    },
  },
  PointsBalance: {
    default: {
      horizontalPadding: 'full-width',
    },
  },
  PointsRedemption: {
    default: {
      pointsExchangedImage: null,
    },
  },
  PointsTiers: {
    default: {
      activeDotColor: '#00491e',
      earnImage: '',
      inactiveDotColor: '#00491e',
      progressBarColor: '#97d700',
      tierImages: [],
    },
  },
  WelcomeBanner: {
    default: {
      backgroundColor: null,
      pointsColor: null,
      rewardsColor: null,
      tierImages: [],
      visible: false,
    },
  },
  'Rewards:Profile': {
    default: {
      membershipImage: '',
    },
  },
  SimpleRewardsList: {
    default: {
      claimButtonVisible: false,
      redeemRewardNote: false,
      showEmptyState: false,
    },
  },
  StepDots: {
    default: {
      activeColour: theme.color.black,
      inactiveColour: theme.color.lightGrey,
    },
  },
  StepIcon: {
    default: {
      circleColour: '',
      iconColour: '',
      visible: true,
    },
    Step1: {
      icon: '',
    },
    Step2: {
      icon: '',
    },
    Step3: {
      icon: '',
    },
  },
  WalletPass: {
    default: {
      align: '',
    },
    Welcome: {
      align: 'center',
    },
  },
  Title: {
    default: {
      fontSize: {
        level1: theme.fontSize.xxl,
        level2: theme.fontSize.xl,
        level3: theme.fontSize.lg,
        level4: theme.fontSize.md,
      },
      fontWeight: theme.fontWeight.bold,
      color: theme.color.black,
      secondaryFontFamily: false,
      textTransform: 'initial',
    },
    'Articles:Horizontal:Large': {},
    'Articles:Horizontal:Small': {
      fontSize: {
        level2: theme.fontSize.xs,
      },
    },
    'Articles:Vertical:Large': {},
    'Articles:Vertical:Small': {
      fontSize: {
        level2: theme.fontSize.sm,
      },
    },
    BackButtonHeader: {
      color: 'inherit',
    },
    BundleCustomization: {
      fontWeight: theme.fontWeight.light,
    },
    Introduction: {
      fontSize: {
        level1: '32px',
      },
    },
    LoyaltyAuthCardLoggedIn: {},
    LoyaltyAuthCardLoggedOut: {},
    LoyaltyModal: {
      fontSize: {
        level1: '48px',
      },
    },
    Modal: {
      fontWeight: theme.fontWeight.light,
    },
    UserProfileModal: {
      fontWeight: theme.fontWeight.medium,
    },
    Onboarding: {
      fontSize: {
        level1: '32px',
      },
    },
    'OrderConfirmationPage:ConfirmationTextLabel': {
      fontSize: {
        level1: '2em',
      },
    },
    OrderDetails: {
      fontSize: {
        level1: '100px',
        level2: theme.fontSize.xl,
        level3: theme.fontSize.md,
      },
    },
    PanelHeader: {},
    PointsTiers: {
      fontSize: {
        level2: theme.fontSize.xxl,
      },
    },
    'Rewards:OfflinePoints': {
      color: theme.color.white,
    },
    'Rewards:OfflinePoints:Success': {
      color: theme.color.white,
    },
    StoreSelection: {
      fontSize: {
        level1: '60px',
        level2: '48px',
      },
    },
    SubscriptionsModal: {
      fontSize: {
        level1: theme.fontSize.xxl,
      },
    },
    Welcome: {},
    'Welcome:Subscriptions:Subscribe': {
      color: theme.color.white,
      fontSize: {
        level3: theme.fontSize.xl,
      },
    },
  },
  Text: {
    default: {
      backgroundColor: '',
      fontSize: {
        level1: theme.fontSize.xxl,
        level2: theme.fontSize.xl,
        level3: theme.fontSize.lg,
        level4: theme.fontSize.md,
        level5: theme.fontSize.sm,
      },
      secondaryFontFamily: false,
      textTransform: '',
    },
    'AddWalletPassToWallet:Loading': {},
    'AddWalletPassToWallet:Error': {},
    'Profile:AddWalletPassToWallet:Loading': {
      color: theme.color.grey,
    },
    'Profile:AddWalletPassToWallet:Error': {},
    'Welcome:AddWalletPassToWallet:Loading': {
      align: 'center',
      color: theme.color.white,
    },
    'Welcome:AddWalletPassToWallet:Error': {
      align: 'center',
    },
    'Articles:Horizontal:Large:Description': {},
    'Articles:Vertical:Large:Description': {},
    'Articles:Vertical:Small:Description': {},
    Bolder: {
      fontWeight: theme.fontWeight.bold,
    },
    BolderLarge: {
      fontSize: {
        level1: theme.fontSize.xxxl,
      },
      fontWeight: 700,
    },
    Introduction: {
      color: theme.color.grey,
    },
    KioskConfigButtonSubtitle: {},
    KioskConfigButtonTitle: {},
    KioskHeader: {},
    LoyaltyAuthCardLoggedIn: {},
    LoyaltyAuthCardLoggedOut: {},
    LoyaltyAuthCardLoggedOutSecondDescription: {},
    'LoyaltyModal:Points': {
      fontSize: {
        level1: '96px',
      },
    },
    NutritionalLawText: {
      color: theme.color.black,
    },
    Onboarding: {
      color: theme.color.grey,
    },
    'PointsRedemption:AfterExchanged:PointsExchanged': {},
    'PointsRedemption:AfterExchanged:Note': {
      color: theme.color.grey,
    },
    'PointsRedemption:BeforeExchanged:Cash': {
      color: theme.color.black,
      fontSize: { level1: '48px' },
    },
    'PointsRedemption:BeforeExchanged:PointsToExchange': {
      color: theme.color.black,
      fontSize: { level5: '14px' },
    },
    'PointsTiers:TierName': {
      textTransform: 'uppercase',
    },
    RewardCounter: {},
    'Rewards:History': {
      fontSize: { level1: theme.fontSize.xl },
      fontWeight: theme.fontWeight.bold,
    },
    'Rewards:MemberNumber': {},
    'Rewards:OfflinePoints': {
      color: theme.color.white,
    },
    'Rewards:OfflinePoints:Success': {
      color: theme.color.white,
    },
    'StoreSelection:StoreStatus:Open': {
      fontWeight: theme.fontWeight.bold,
      fontSize: {
        level3: theme.fontSize.md,
      },
      color: theme.color.success,
    },
    'StoreSelection:StoreStatus:Closed': {
      fontWeight: theme.fontWeight.bold,
      fontSize: {
        level3: theme.fontSize.md,
      },
      color: theme.color.grey,
    },
    'StoreSelection:DeliveryStatus': {
      fontWeight: theme.fontWeight.bold,
      fontSize: {
        level3: theme.fontSize.md,
      },
      color: theme.color.info,
    },
    'StoreSelection:UnavailableDelivery': {
      fontSize: {
        level3: theme.fontSize.sm,
      },
      color: theme.color.danger,
    },
    SystemDetails: {
      fontWeight: theme.fontWeight.medium,
    },
    'Welcome:MemberCode': {
      color: theme.color.white,
    },
    'Welcome:MemberNumber': {
      color: theme.color.black,
      fontWeight: theme.fontWeight.bold,
      backgroundColor: theme.color.white,
    },
    'Welcome:MemberNumberQr': {
      color: theme.color.white,
      fontWeight: theme.fontWeight.bold,
    },
    'Welcome:OrderNow': {},
    'Welcome:Rewards': {},
    'Welcome:Subscriptions:Manage:Description': {
      color: theme.color.white,
    },
    'Welcome:Subscriptions:Subscribe:Description': {
      color: theme.color.white,
    },
  },
  Table: {
    default: {
      backgroundColor: 'transparent',
      border: 0,
      borderRadius: 0,
      fontSize: 'inherit',
      padding: '0',
      textAlign: 'left',
      Cell: {
        border: 0,
        fontSize: theme.fontSize.md,
        fontWeight: theme.fontWeight.medium,
        padding: '10px 12px',
      },
      HeadCell: {
        border: '',
        fontSize: '',
        fontWeight: '',
        padding: '',
      },
      Row: {
        borderRadius: 0,
        border: theme.stroke.light,
      },
    },
    'Rewards:History': {
      fontSize: theme.fontSize.md,
      Row: {
        border: 0,
        borderRadius: theme.borderRadius.medium,
      },
      HeadCell: {
        fontWeight: theme.fontWeight.bold,
        padding: '10px 24px',
      },
      Cell: {
        border: 0,
        fontWeight: theme.fontWeight.regular,
        padding: '16px 24px',
      },
    },
    'Settings:Printer': {
      Cell: {
        padding: '12px 0',
      },
    },
    SystemDetails: {
      border: theme.stroke.light,
      borderRadius: theme.borderRadius.medium,
      padding: '32px 32px 16px',
      Cell: {
        fontSize: theme.fontSize.xl,
        padding: '16px 0',
      },
    },
  },
  CardButton: {
    default: {
      hideText: false,
      backgroundImage: '',
      backgroundColor: '',
    },
  },
  Card: {
    default: {
      Container: {
        backgroundColor: theme.color.white,
        borderRadius: theme.borderRadius.large,
        boxShadow: theme.boxShadow.small,
        showInfoButton: false,
        highlightActiveBorder: false,
        borderColor: '',
        borderWidth: '3px',
        defaultBorder: null,
        defaultBorderColor: null,
        fillColor: '',
      },
      Image: {
        borderBottomRadius: '0px',
      },
      Content: {
        padding: '16px',
      },
      Title: {
        secondaryFontFamily: false,
        fontSize: theme.fontSize.lg,
        fontWeight: theme.fontWeight.bold,
        color: theme.color.black,
        textTransform: 'initial',
        truncateLines: 3,
      },
      Subtitle: {
        visible: false,
        fontSize: theme.fontSize.sm,
        fontWeight: theme.fontWeight.regular,
        color: theme.color.grey,
        truncateLines: 3,
      },
      Servings: {
        visible: true,
        fontSize: theme.fontSize.sm,
        fontWeight: theme.fontWeight.regular,
        color: theme.color.grey,
      },
      Description: {
        visible: false,
        fontSize: theme.fontSize.md,
        fontWeight: theme.fontWeight.medium,
        color: theme.color.grey,
        truncateLines: 2,
      },
      Disclaimer: {
        visible: false,
        fontSize: theme.fontSize.md,
        fontWeight: theme.fontWeight.regular,
        color: theme.color.grey,
      },
      Header: {
        marginBottom: '8px',
      },
      StockQuantity: {
        visible: true,
        color: theme.color.warning,
        fontWeight: theme.fontWeight.bold,
        fontSize: theme.fontSize.md,
      },
      Fees: {
        visible: true,
        color: theme.color.black,
        fontWeight: theme.fontWeight.light,
        fontSize: theme.fontSize.xs,
      },
      PackagingInfo: {
        visible: true,
        color: theme.color.black,
        fontWeight: theme.fontWeight.light,
        fontSize: theme.fontSize.xs,
      },
      Footer: {
        LeftSide: {
          fontSize: theme.fontSize.md,
          fontWeight: theme.fontWeight.regular,
          color: theme.color.black,
        },
        RightSide: {
          visible: false,
          fontSize: theme.fontSize.md,
          fontWeight: theme.fontWeight.regular,
          color: theme.color.black,
        },
      },
      'Overlay:off': {
        backgroundColor: theme.color.black,
        alignItems: 'center',
        textAlign: 'center',
        Label: {
          color: theme.color.white,
          backgroundColor: theme.color.black,
          fontSize: theme.fontSize.md,
          borderRadius: theme.borderRadius.ellipse,
        },
      },
      'Overlay:off-today': {
        backgroundColor: theme.color.black,
        alignItems: 'center',
        textAlign: 'center',
        Label: {
          color: theme.color.white,
          backgroundColor: theme.color.black,
          fontSize: theme.fontSize.md,
          borderRadius: theme.borderRadius.ellipse,
        },
      },
      'Overlay:timedAvailability': {
        backgroundColor: theme.color.black,
        alignItems: 'center',
        textAlign: 'center',
        Label: {
          color: theme.color.white,
          backgroundColor: theme.color.black,
          fontSize: theme.fontSize.md,
          borderRadius: theme.borderRadius.ellipse,
        },
      },
    },
    'Articles:Horizontal:Large': {
      Container: {
        defaultBorder: theme.stroke.default,
        defaultBorderColor: 'transparent',
      },
    },
    'Articles:Horizontal:Small': {
      Container: {
        defaultBorder: theme.stroke.default,
        defaultBorderColor: 'transparent',
      },
      Content: {
        padding: '12px',
      },
    },
    'Articles:Vertical:Large': {
      Container: {
        defaultBorder: theme.stroke.default,
        defaultBorderColor: 'transparent',
      },
    },
    Demo: {
      Container: {
        showInfoButton: true,
      },
    },
    MenuCard: {
      Title: {
        fontSize: theme.fontSize.xl,
        fontWeight: theme.fontWeight.medium,
      },
      Footer: {
        'LeftSide:DiscountedPrice': {
          visible: true,
          color: theme.color.danger,
        },
        RightSide: {
          color: theme.color.grey,
        },
      },
    },
    MealCard: {
      Title: {
        fontWeight: theme.fontWeight.medium,
      },
      Footer: {
        LeftSide: {
          color: theme.color.grey,
        },
        RightSide: {
          color: theme.color.grey,
        },
      },
    },
    ReorderCard: {
      Container: {
        showInfoButton: false,
        borderRadius: theme.borderRadius.medium,
      },
      Title: {
        fontSize: theme.fontSize.xl,
        fontWeight: theme.fontWeight.medium,
        color: theme.color.black,
      },
      Header: {
        flexGrow: 'initial',
        marginBottom: '16px',
      },
      Footer: {
        LeftSide: {
          fontSize: theme.fontSize.md,
          fontWeight: theme.fontWeight.regular,
          color: theme.color.black,
        },
        RightSide: {
          visible: true,
          fontSize: theme.fontSize.md,
          fontWeight: theme.fontWeight.regular,
        },
      },
    },
    UpsellCard: {
      Title: {
        fontWeight: theme.fontWeight.medium,
      },
      Footer: {
        LeftSide: {
          color: theme.color.grey,
        },
        RightSide: {
          color: theme.color.grey,
        },
      },
    },
  },
  ListCard: {
    default: {
      'Label:off': {
        color: theme.color.white,
        backgroundColor: theme.color.black,
        fontSize: theme.fontSize.md,
        borderRadius: theme.borderRadius.ellipse,
      },
      'Label:off-today': {
        color: theme.color.white,
        backgroundColor: theme.color.black,
        fontSize: theme.fontSize.md,
        borderRadius: theme.borderRadius.ellipse,
      },
      'Label:timedAvailability': {
        color: theme.color.white,
        backgroundColor: theme.color.black,
        fontSize: theme.fontSize.md,
        borderRadius: theme.borderRadius.ellipse,
      },
      Container: {
        boxShadow: theme.boxShadow.small,
        borderRadius: theme.borderRadius.large,
        backgroundColor: theme.color.white,
        defaultBorder: null,
        defaultBorderColor: null,
        hasPadding: false,
        showBottomBorder: true,
      },
      Title: {
        fontSize: theme.fontSize.lg,
        fontWeight: theme.fontWeight.medium,
        color: theme.color.black,
      },
      Subtitle: {
        fontSize: theme.fontSize.md,
        fontWeight: theme.fontWeight.regular,
        color: theme.color.grey,
        truncateLines: 1,
      },
      Image: {
        borderRadius: theme.borderRadius.large,
      },
      Footer: {
        LeftSide: {
          color: theme.color.grey,
          fontSize: theme.fontSize.md,
          fontWeight: theme.fontWeight.regular,
        },
        RightSide: {
          visible: false,
          color: theme.color.grey,
          fontSize: theme.fontSize.md,
          fontWeight: theme.fontWeight.regular,
        },
      },
      Text: {
        fontSize: theme.fontSize.md,
        fontWeight: theme.fontWeight.regular,
        color: theme.color.grey,
      },
      Description: {
        visible: false,
        fontSize: theme.fontSize.md,
        fontWeight: theme.fontWeight.medium,
        color: theme.color.grey,
        truncateLines: 2,
      },
      Servings: {
        visible: true,
        fontSize: theme.fontSize.md,
        fontWeight: theme.fontWeight.regular,
        color: theme.color.grey,
        truncateLines: 1,
      },
      Disclaimer: {
        visible: false,
        fontSize: theme.fontSize.md,
        fontWeight: theme.fontWeight.regular,
        color: theme.color.grey,
      },
      StockQuantity: {
        visible: true,
        color: theme.color.warning,
        fontWeight: theme.fontWeight.bold,
        fontSize: theme.fontSize.md,
      },
      Fees: {
        visible: true,
        color: theme.color.black,
        fontWeight: theme.fontWeight.light,
        fontSize: theme.fontSize.xs,
      },
      PackagingInfo: {
        visible: true,
        color: theme.color.black,
        fontWeight: theme.fontWeight.light,
        fontSize: theme.fontSize.xs,
      },
      KioskPaymentFee: {
        fontSize: theme.fontSize.md,
        fontWeight: theme.fontWeight.regular,
        color: theme.color.grey,
      },
    },
    'Articles:Vertical:Small': {
      Container: {
        border: theme.stroke.default,
        defaultBorder: theme.stroke.default,
        defaultBorderColor: 'transparent',
        hasPadding: false,
        showBottomBorder: false,
      },
      Description: {
        visible: false,
      },
    },
    UpsellDealCard: {
      Container: {
        hasPadding: true,
      },
      Subtitle: {
        truncateLines: 'unset',
      },
    },
    EmptyCard: {},
  },
  LoyaltyLogo: {
    default: {
      logo: '',
      visible: true,
    },
    SimpleRewardsList: {},
    HeaderLoggedIn: {},
    HeaderLoggedOut: {},
    'Welcome:Rewards': {},
  },
  CheckoutCard: {
    default: {
      Subtitle: {
        fontSize: theme.fontSize.sm,
        color: theme.color.grey,
        visible: false,
      },
      Fees: {
        fontSize: theme.fontSize.sm,
        color: theme.color.grey,
        visible: true,
      },
      PackagingInfo: {
        fontSize: theme.fontSize.sm,
        color: theme.color.grey,
        visible: true,
      },
      Servings: {
        fontSize: theme.fontSize.sm,
        color: theme.color.grey,
        visible: true,
      },
    },
  },
  Poster: {
    default: {
      Container: {
        borderRadius: theme.borderRadius.large,
        boxShadow: theme.boxShadow.small,
        alignItems: 'flex-end',
        textAlign: 'left',
      },
      Title: {
        color: theme.color.black,
        secondaryFontFamily: false,
        textTransform: 'initial',
        fontSize: theme.fontSize.xxl,
        backgroundColor: '',
        borderRadius: '0px',
        padding: '0px',
      },
    },
    CategoryPoster: {},
  },
  Sidebar: {
    default: {
      mode: 'dark',
      backgroundColor: theme.color.black,
    },
  },
  QuantityCounter: {
    default: {
      unitLabel: false,
    },
  },
  'StoreSelection:StoreCard': {
    default: {
      AppType: {
        visible: true,
      },
      StoreHours: {
        visible: true,
      },
      MenuHours: {
        visible: true,
      },
      MenuName: {
        visible: true,
      },
    },
  },
  Navbar: {
    default: {
      Title: {
        visible: true,
      },
      Container: {
        backgroundColor: theme.color.white,
      },
      Link: {
        color: theme.color.black,
        fontSize: theme.fontSize.sm,
        fontWeight: theme.fontWeight.regular,
        secondaryFontFamily: false,
        textTransform: undefined,
        truncateLines: undefined,
        backgroundColor: undefined,
        activeColor: '',
        textDecoration: 'none',
      },
    },
    vertical: {
      Container: {
        backgroundColor: undefined,
        gap: undefined,
        padding: undefined,
      },
      Image: {
        borderRadius: '',
        width: '80px',
        visible: true,
      },
      Link: {
        fontSize: theme.fontSize.lg,
        activeBackgroundColor: undefined,
        isActiveBarVisible: true,
        borderRadius: undefined,
        boxShadow: undefined,
      },
    },
  },
  Header: {
    default: {
      Container: {
        backgroundColor: theme.color.white,
      },
      Text: {
        secondaryFontFamily: false,
      },
      ProfileBackButton: {
        visible: true,
      },
    },
    Main: {
      Container: {
        backgroundColor: theme.color.white,
      },
      Text: {
        color: theme.color.black,
      },
    },
    Secondary: {
      Container: {
        backgroundColor: theme.color.white,
      },
      Text: {
        color: theme.color.black,
      },
    },
  },
  Button: {
    default: {
      backgroundImage: '',
      hideContent: false,
      textDecoration: 'none',
      textTransform: 'initial',
    },
    Primary: {
      color: theme.color.white,
    },
    Outline: {
      backgroundColor: theme.color.white,
    },
    Light: {
      backgroundColor: theme.color.white,
      borderColor: theme.color.lightGrey,
      color: theme.color.black,
      selected: {
        backgroundColor: '',
        borderColor: '',
        color: '',
      },
    },
    Ghost: {},
    Link: {
      fontSize: {
        level1: theme.fontSize.xxl,
        level2: theme.fontSize.xl,
        level3: theme.fontSize.lg,
        level4: theme.fontSize.md,
        level5: theme.fontSize.sm,
      },
      textDecoration: 'underline',
    },
    AccessibilityLight: {},
    KioskConfigPrimary: {},
    KioskConfigLight: {},
    LanguageLight: {},
    UpsellToDealCTA: {
      color: theme.color.white,
      textTransform: 'uppercase',
    },
  },
  Loader: {
    default: {},
  },
  Textarea: {
    default: {},
    Feedback: {},
  },
  CheckListItem: {
    default: {
      Content: {
        color: theme.color.grey,
        fontSize: theme.fontSize.md,
      },
      Footer: {
        color: theme.color.grey,
        fontSize: theme.fontSize.sm,
        visible: false,
      },
    },
  },
  Chip: {
    default: {
      borderRadius: theme.borderRadius.ellipse,
      borderColor: theme.color.lightGrey,
      color: theme.color.black,
    },
  },
  LayoutCard: {
    default: {
      backgroundColor: theme.color.white,
      backgroundImage: '',
      padding: '32px',
    },
    'Kiosk:Settings': {
      border: theme.stroke.light,
    },
    'Kiosk:Settings:Printer': {
      padding: '24px',
    },
    'Rewards:History': {},
    'Rewards:HowItWorks': {},
    'Rewards:LoyaltyStamps:Section': {},
    'Rewards:LoyaltyStamps': {},
    'Rewards:Membership': {},
    'Rewards:OfflinePoints:Success': {
      backgroundColor: theme.color.success,
    },
    'Rewards:PointsBalance': {},
    'Rewards:TierSystem': {},
    'Rewards:UserRewards': {},
    Stamps: {
      headerImage: '',
      illustrationImage: '',
      inactiveIcon: '',
      activeIcon: '',
    },
    'Welcome:LoyaltyStamps': {},
    'Welcome:MemberCode': {
      align: 'center',
      backgroundColor: theme.color.black,
    },
    'Welcome:OrderNow': {
      align: 'center',
      backgroundColor: theme.color.lighterGrey,
    },
    'Welcome:Rewards': {
      align: 'center',
    },
    'Welcome:Subscriptions:Manage': {
      align: 'center',
      backgroundColor: theme.color.black,
    },
    'Welcome:Subscriptions:Subscribe': {
      align: 'center',
      backgroundColor: theme.color.black,
    },
  },
  Rewards: {
    default: {
      visible: true,
    },
  },
  NativeFooter: {
    default: {
      firstIcon: '',
      secondIcon: '',
      thirdIcon: '',
      fourthIcon: '',
      navbarColor: '',
      activeMenuColorText: '',
      menuColorTextOnIdle: '',
      iconColor: '#808080',
      activeIconColor: '',
    },
  },
  Separator: {
    default: {
      backgroundColor: theme.color.lightGrey,
    },
    'Welcome:Rewards': {},
  },
  Radio: {
    default: {
      hover: {
        iconColor: '',
      },
      selected: {
        iconColor: '',
      },
      unselected: {
        iconColor: '',
      },
    },
  },
  Copyright: {
    default: {
      mode: 'light',
    },
  },
  SplashScreen: {
    default: {
      backgroundColor: theme.color.white,
      backgroundImage: '',
    },
  },
  SwitchGroup: {
    default: {
      selectedColor: '',
    },
  },
  UserReward: {
    default: {
      backgroundColor: theme.color.white,
      border: '',
      borderRadius: '',
      boxShadow: 'none',
      color: theme.color.grey,
      titleColor: theme.color.black,
    },
  },
  Logo: {
    default: {
      xsmall: {
        minWidth: '40px',
        maxHeight: '40px',
        maxWidth: '80px',
      },
      small: {
        minWidth: '40px',
        maxHeight: '40px',
        maxWidth: '160px',
      },
      medium: {
        minWidth: '48px',
        maxHeight: '48px',
        maxWidth: '200px',
      },
    },
  },
  Tabs: {
    default: {
      borderRadius: `${theme.borderRadius.small} ${theme.borderRadius.small} 0 0`,
      fontSize: theme.fontSize.md,
    },
    MealDealCategories: {
      borderRadius: 0,
      color: theme.color.black,
      backgroundColor: theme.color.white,
      fontSize: theme.fontSize.xl,
    },
  },
  Modal: {
    default: {
      overlayBackgroundImage: '',
      borderRadius: '',
    },
    QRScan: {
      overlayBackgroundImage: '',
      ScanImage: {
        backgroundURL: '',
        width: '400px',
        height: '400px',
      },
    },
    UpsellToDeal: {
      updateToV2: false,
      borderRadius: '32px',
    },
    ExternalPayAtCounterModal: {
      borderRadius: '16px',
      ExtraComponent: {
        borderRadius: '16px',
        backgroundColor: 'white',
        bottom: '80px',
        right: '100px',
        top: '',
        left: '',
        padding: '10px',
      },
    },
    UserProfileModal: {
      Header: {
        boxShadow: 'none',
      },
    },
  },
  Container: {
    default: {
      backgroundColor: '',
    },
    UpsellCategories: {
      backgroundColor: '',
    },
    Customization: {
      backgroundColor: '',
    },
  },
  PaymentMethodCards: {
    default: {
      payByCardIcon: 'Card',
      payAtCounterIcon: 'MoneyBill',
    },
    Kiosk: {
      payByCardIcon: 'Card',
      payAtCounterIcon: 'MoneyBill',
      payByCardImage: '',
    },
  },
  Badge: {
    default: {
      backgroundColor: '',
      borderColor: '',
      color: '',
    },
    CategoryHeader: {},
    RewardCounter: {},
    'Welcome:Subscriptions:Manage': {},
  },
  'Subscriptions:Rewards': {
    default: {
      subscribe: {
        descriptionVisible: true,
        image: '',
        infoIconVisible: true,
        priceVisible: true,
      },
      manage: {
        descriptionVisible: true,
        image: '',
      },
    },
  },
  'Subscriptions:Welcome': {
    default: {
      subscribe: {
        descriptionVisible: true,
        image: '',
        titleVisible: true,
      },
      manage: {
        image: '',
      },
    },
  },
  SubscriptionsModal: {
    default: {
      image: '',
    },
  },
  ProgressBar: {
    default: {
      borderRadius: theme.borderRadius.ellipse,
      valueRadius: theme.borderRadius.ellipse,
    },
    ModalHeader: {
      borderRadius: 0,
      valueRadius: '0 100px 100px 0',
    },
  },
});

export const componentsThemeMobile = mobileTheme => ({
  Alert: {
    'Rewards:OfflinePoints': {
      fontSize: {
        small: mobileTheme.fontSize.sm,
      },
    },
  },
  Button: {
    Link: {
      fontSize: {
        level1: mobileTheme.fontSize.xl,
        level2: mobileTheme.fontSize.lg,
        level3: mobileTheme.fontSize.md,
        level4: mobileTheme.fontSize.sm,
        level5: mobileTheme.fontSize.xs,
      },
    },
  },
  ListCard: {
    default: {
      Container: {
        hasPadding: true,
      },
    },
  },
  Tabs: {
    MealDealCategories: {
      fontSize: mobileTheme.fontSize.lg,
    },
  },
  Title: {
    default: {
      fontSize: {
        level1: mobileTheme.fontSize.xl,
        level2: mobileTheme.fontSize.lg,
        level3: mobileTheme.fontSize.md,
        level4: mobileTheme.fontSize.sm,
      },
    },
    Introduction: {},
    StoreSelection: {
      fontSize: {
        level1: mobileTheme.fontSize.xxl,
        level2: mobileTheme.fontSize.xxl,
      },
    },
    'OrderHistory:NoOrders': {
      fontSize: {
        level2: mobileTheme.fontSize.xl,
      },
    },
    UserProfileModal: {
      fontSize: {
        level1: mobileTheme.fontSize.lg,
        level2: mobileTheme.fontSize.md,
        level3: mobileTheme.fontSize.sm,
        level4: mobileTheme.fontSize.xs,
      },
    },
  },
  Text: {
    default: {
      fontSize: {
        level1: mobileTheme.fontSize.xl,
        level2: mobileTheme.fontSize.lg,
        level3: mobileTheme.fontSize.md,
        level4: mobileTheme.fontSize.sm,
        level5: mobileTheme.fontSize.xs,
      },
    },
    'Profile:AddWalletPassToWallet:Loading': {
      fontSize: {
        level5: mobileTheme.fontSize.sm,
      },
    },
    'Profile:AddWalletPassToWallet:Error': {
      fontSize: {
        level5: mobileTheme.fontSize.sm,
      },
    },
    'Welcome:AddWalletPassToWallet:Loading': {
      fontSize: {
        level5: mobileTheme.fontSize.sm,
      },
    },
    'Welcome:AddWalletPassToWallet:Error': {
      fontSize: {
        level5: mobileTheme.fontSize.sm,
      },
    },
  },
  Logo: {
    default: {
      xsmall: {
        maxHeight: '32px',
        minWidth: '32px',
        maxWidth: '80px',
      },
      small: {
        maxHeight: '32px',
        minWidth: '32px',
        maxWidth: '160px',
      },
    },
  },
  Table: {
    'Rewards:History': {
      fontSize: mobileTheme.fontSize.sm,
      HeadCell: {
        padding: '10px 12px',
      },
      Cell: {
        padding: '16px 12px',
      },
    },
  },
});

export const componentsThemeKiosk = kioskTheme => ({
  Alert: {
    default: {
      fontSize: {
        small: kioskTheme.fontSize.md,
        large: kioskTheme.fontSize.md,
      },
    },
  },
  Button: {
    Link: {
      fontSize: {
        level1: kioskTheme.fontSize.xxl,
        level2: kioskTheme.fontSize.xl,
        level3: kioskTheme.fontSize.lg,
        level4: kioskTheme.fontSize.md,
        level5: kioskTheme.fontSize.sm,
      },
    },
  },
  Title: {
    default: {
      fontSize: {
        level1: kioskTheme.fontSize.xxl,
        level2: kioskTheme.fontSize.xl,
        level3: kioskTheme.fontSize.lg,
      },
    },
    Introduction: {},
    QrScanModal: {
      fontSize: {
        level1: '64px',
      },
    },
  },
  Text: {
    default: {
      fontSize: {
        level1: kioskTheme.fontSize.xxl,
        level2: kioskTheme.fontSize.xl,
        level3: kioskTheme.fontSize.lg,
        level4: kioskTheme.fontSize.md,
        level5: kioskTheme.fontSize.sm,
      },
    },
  },
  Card: {
    default: {
      Title: {
        fontSize: kioskTheme.fontSize.lg,
      },
      Subtitle: {
        fontSize: kioskTheme.fontSize.sm,
      },
      Footer: {
        LeftSide: {
          fontSize: kioskTheme.fontSize.md,
        },
        RightSide: {
          fontSize: kioskTheme.fontSize.md,
        },
      },
    },
    MenuCard: {
      Title: {
        fontSize: kioskTheme.fontSize.xl,
      },
    },
  },
  ListCard: {
    default: {
      Title: {
        fontSize: kioskTheme.fontSize.lg,
      },
      Subtitle: {
        fontSize: kioskTheme.fontSize.md,
      },
      KioskPaymentFee: {
        fontSize: kioskTheme.fontSize.md,
      },
    },
  },
  Tabs: {
    MealDealCategories: {
      fontSize: kioskTheme.fontSize.xxl,
    },
  },
  Navbar: {
    vertical: {
      Link: {
        fontSize: kioskTheme.fontSize.lg,
      },
    },
  },
});

export const componentsThemeLargeScreenKiosk = () => ({
  Logo: {
    default: {
      medium: {
        maxHeight: '48px',
        minWidth: '48px',
        maxWidth: '48px',
      },
    },
    VerticalSideNav: {
      medium: {
        maxHeight: '64px',
        maxWidth: 'none',
      },
    },
  },
});
